// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"2dcf5719","698":"a3d14080"}[chunkId] + ".chunk.js";
};